import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { getClientContext } from '@shared/utils/get-client-context';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const message =
        error.error?.message ?? error.error?.error ?? error.message;

      const err = new Error(message);
      err.name = 'HttpErrorResponse';

      Sentry.withScope((scope) => {
        scope.setTransactionName(`${req.method} ${req.url}`);
        scope.setContext('client', getClientContext());

        Sentry.captureException(err);
      });

      return throwError(() => error);
    }),
  );
};
